import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { DvlSettingsService } from '../../../services/settings.service';

@Component({
  selector: '[dvl-attendee-form]',
  templateUrl: './attendee-form.component.html'
})
export class DvlAttendeeFormComponent {
  @Input() foodMandatory: boolean;
  @Input() index: number;
  @Input() attendee: any;
  @Input() creationForm: boolean;
  @Output('submit') submitEmitter: EventEmitter<any>;
  @Output('error') errorEmitter: EventEmitter<string>;
  @Output('deleteAttendee') deleteEmitter: EventEmitter<any>;
  @ViewChild('noteInput') noteInput: ElementRef;
  @ViewChild('infoInput') infoInput: ElementRef;
  @ViewChild('nameInput') nameInput: ElementRef;

  private showFoodPicker: boolean;
  private showDeleteConfirm: boolean;
  private foods: any[];

  constructor(private settingsService: DvlSettingsService) {
    this.submitEmitter = new EventEmitter<any>();
    this.errorEmitter = new EventEmitter<string>();
    this.deleteEmitter = new EventEmitter<any>();
    this.attendee = {};
    this.showFoodPicker = false;
    this.showDeleteConfirm = false;

    this.settingsService.foods$.subscribe((foods) => this.foods = foods);
  }

  private setFood(food: any): void {
    this.attendee = Object.assign({}, this.attendee, { food: food.$key });

    /*if (!this.creationForm) { */
    this.submit();
    /*}
      this.noteInput.nativeElement.focus();
    */
  }

  private submit() {
    if (!this.foodMandatory || (this.foodMandatory && this.attendee.food)) {
      this.submitEmitter.emit(this.attendee);

      if (this.creationForm) {
        this.clear();
      }
    } else {
      this.errorEmitter.emit("Esta comanda ya fue enviada a cocina. Necesita definir la comida para el nuevo invitado.");
    }
  }

  private onChange(): void {
    if (!this.creationForm) {
      this.submit();
    }
  }

  private onHangerTab(keypress: any): void {
    this.showFoodPicker = true;
  }

  private onNotesTab(keypress: any): void {
    if (this.creationForm) {
      this.submit();
    }
  }

  private onDeleteAttendee() : void {
    this.deleteEmitter.emit(this.attendee);
    this.showDeleteConfirm = false;
  }

  focusName(): void {
    this.nameInput.nativeElement.focus();
  }

  clear(): void {
    this.attendee = {};
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/reception/components/attendee-form/attendee-form.component.ts